import script from "./CloseAccountDataMgmt.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloseAccountDataMgmt.vue?vue&type=script&setup=true&lang=ts"

import "./CloseAccountDataMgmt.vue?vue&type=style&index=0&id=14a928f9&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14a928f9"]])

export default __exports__